import { SupportingDocumentsOutPutFileUploadApi } from '../../Apis/user/ApiConfig';
import {
    SUPPORTING_DOCUMENTS_OUT_PUT_FILE_UPLOAD_SUCCESS,
    SUPPORTING_DOCUMENTS_OUT_PUT_FILE_UPLOAD_ERROR,
    SUPPORTING_DOCUMENTS_OUT_PUT_FILE_UPLOAD_REQUEST,
    SUPPORTING_DOCUMENTS_OUT_PUT_FILE_UPLOAD_CLEAR,
} from '../../Types/user/Types';

export const SupportingDocumentsOutPutFileUploadSuccess = (res) => {
    return {
        type: SUPPORTING_DOCUMENTS_OUT_PUT_FILE_UPLOAD_SUCCESS,
        payload: res,
    };
};
export const SupportingDocumentsOutPutFileUploadError = (error) => {
    return {
        type: SUPPORTING_DOCUMENTS_OUT_PUT_FILE_UPLOAD_ERROR,
        error: error,
    };
};
export const SupportingDocumentsOutPutFileUploadRequest = (res) => {
    return {
        type: SUPPORTING_DOCUMENTS_OUT_PUT_FILE_UPLOAD_REQUEST,
        payload: res,
    };
};
export const SupportingDocumentsOutPutFileUploadClear = () => ({
    type: SUPPORTING_DOCUMENTS_OUT_PUT_FILE_UPLOAD_CLEAR,
});
export const SupportingDocumentsOutPutFileUploadActionHandler = (data) => {
    return (dispatch) => {
        dispatch(SupportingDocumentsOutPutFileUploadRequest());
        try {
            SupportingDocumentsOutPutFileUploadApi(data)
                .then((res) => {
                    const errorMessage = res?.data?.message;
                    if (res) {
                        if (res && res.data && res.status === 201) {
                            dispatch(
                                SupportingDocumentsOutPutFileUploadSuccess(
                                    res.data
                                )
                            );
                        } else {
                            dispatch(
                                SupportingDocumentsOutPutFileUploadError(
                                    errorMessage
                                )
                            );
                        }
                    } else {
                        dispatch(
                            SupportingDocumentsOutPutFileUploadError(
                                errorMessage
                            )
                        );
                    }
                })
                .catch((err) => {
                    dispatch(
                        SupportingDocumentsOutPutFileUploadError(
                            'Something Went Wrong!!!'
                        )
                    );
                });
        } catch (err) {
            dispatch(SupportingDocumentsOutPutFileUploadError(err));
        }
    };
};
